<template>
	<div class="contains">
		<div class="content-tit">
			<h2>留言记录</h2>
		</div>
		<div class="content-main">
			<div class="kefu-user">
				<div class="content-box">
					<div class="staff_box">
						<el-form :inline="true" :model="Select_Message" class="demo-form-inline">
							<el-form-item label="关键字">
								<el-input placeholder="请输入搜索 关键词/用户名"  v-model="Select_Message.NickName" style="width:250px"  >
									<!-- <input type="text" autocomplete="off" placeholder="请输入内容" />
									<el-button slot="append" icon="el-icon-search" @click="Select_List"></el-button> -->
								</el-input>
							</el-form-item>
							<el-form-item label="留言处理状态">
								<el-select
									placeholder="未处理留言"
									v-model="Select_Message.ProcessingState"
								>
									<el-option v-for="item in option1" :key="item.id" :label="item.name" :value="item.id"></el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="留言分配状态" >
								<el-select placeholder="全部留言" v-model="Select_Message.State">
									<el-option v-for="item in option2" :key="item.id" :label="item.name" :value="item.id"></el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="跟进人" >
								<el-select placeholder="全部跟进人"  v-model="Select_Message.followUp">
									<el-option :key="-1" :value="-1" label="全部跟进人"></el-option>
									<el-option v-for="item in followUp" :key="item.id" :value="item.id" :label="item.nickName"></el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="渠道">
								<el-select placeholder="全部渠道" v-model="Select_Message.channelId">
									<el-option :key="-1" :value="-1" label="全部渠道"></el-option>
									<el-option
										v-for="item in channelEnumList"
										:key="item.id"
										:value="item.id"
										:label="item.name"
									></el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="联络原因"> 
									<consultationTypeTree 
										:currentNodeKey="currentNodeKey" 
										@onSelectedId='onSelectedId'  />
							</el-form-item>
							<el-form-item label="产品名称">
									<productTree :currentNodeKey="currentNodeKeyProduct" @onSelectedId='onSelectedProductId' />
							</el-form-item>
							<el-form-item label="留言时间" >
								<el-date-picker
									v-model="Select_Message.CreateTime"
									type="datetimerange"
									range-separator="至"
									start-placeholder="开始日期"
									end-placeholder="结束日期"
									:picker-options="pickerOptions"
									 
									style="margin-right:10px"
									value-format="yyyy-MM-dd HH:mm:ss"
								></el-date-picker>
							</el-form-item>
							<el-form-item label="联系规格" prop="contactSpecificationsId">
								<el-select v-model="Select_Message.contactSpecificationsId"  placeholder="请选择">
									<el-option
									:key="0"
									label="全部"
									:value="0">
									</el-option>
									<el-option
									v-for="item in contactSpecificationsList"
									:key="item.id"
									:label="item.name"
									:value="item.id">
									</el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="危机程度" prop="crisisId">
								<el-select v-model="Select_Message.crisisId"  placeholder="请选择">
									<el-option key="0" label="全部" value="0"></el-option>
									<el-option
									v-for="item in crisisList"
									:key="item.id"
									:label="item.crisisName"
									:value="item.id">
									</el-option>
								</el-select>
							</el-form-item>
							 <el-form-item>
								<el-button type="primary" @click="Select_List">查询</el-button>
								<el-button
								@click="export1()"
								type="primary"
								:loading="exportLoading"
								>{{exportLoading?'正在处理...':'导出当前数据'}}</el-button>
								<el-button v-bind:disabled="disabled1" @click="Update(0)">批量分配留言</el-button>
							</el-form-item>
						</el-form>
					</div>
					<div class="include">
						<span class="Message_Sum">
							共
							<span>1</span>项
						</span>
						<div class="table_box" v-loading="mesRecordLoading">
							<!-- </br> -->
							<!-- -->
							<el-table
								ref="multipleTable"
								:data="tableData"
								tooltip-effect="dark"
								style="width: 100%;"
								@row-click="rowClick"
								border
								stripe
								@select="selectCheck"
								@select-all="select_allCheckk"
							>
								<el-table-column type="selection" width="55"></el-table-column>
								<el-table-column prop="NickName" label="用户名"></el-table-column>
								<el-table-column prop="Content" label="留言内容" show-overflow-tooltip></el-table-column>
								<el-table-column prop="SendTime" label="留言时间">
									<template slot-scope="scope">{{formatTime(scope.row.createTime)}}</template>
								</el-table-column>
								<el-table-column prop="State" label="当前状态"></el-table-column>
								<el-table-column prop="typeName" label="联络原因">
									<template slot-scope="scope">
										<el-tooltip class="item" effect="dark" :content="scope.row.typeNameTree" placement="top-start">
											<div> {{scope.row.typeName}}</div>
										</el-tooltip>
									</template>
								</el-table-column>
						 		<el-table-column prop="productName" label="产品名称">
									<template slot-scope="scope">
										<el-tooltip class="item" effect="dark" :content="scope.row.productNameTree" placement="top-start">
											<div> {{scope.row.productName}}</div>
										</el-tooltip>
									</template>
								</el-table-column>
								<el-table-column prop="Name" label="渠道"></el-table-column>
								<el-table-column prop="contactSpecificationsName" label="联系规格"></el-table-column>
								<el-table-column prop="crisisName" label="危机程度"></el-table-column>
								<el-table-column prop="AllocationTime" label="分配时间">
									<template slot-scope="scope">{{formatTime(scope.row.AllocationTime)}}</template>
								</el-table-column>
								<el-table-column prop="ProcessingState" label="处理状态"></el-table-column>
								<el-table-column label="完成时间" prop="completionTime">
									<template slot-scope="scope">{{formatTime(scope.row.completionTime)}}</template>
								</el-table-column>
								<el-table-column prop="UserName" label="跟进人"></el-table-column>

								<el-table-column fixed="right" label="操作" width="100">
									<template slot-scope="scope">
										<i
											class="el-icon-edit"
											prop="RoleName"
											@click.stop="Update(scope.row.operate,scope.row.MiniChannelId)"
										></i>
										<i class="el-icon-download" @click.stop="exportLeavingAMessage(scope.row.accessChatId)"></i>
									</template>
								</el-table-column>
							</el-table>
						</div>
					</div>
					<div class="pagination">
						<el-pagination
							@current-change="List"
							background
							layout="total, prev, pager, next"
							:total="SumUser"
						></el-pagination>
					</div>
				</div>
				<el-dialog title="分配留言" :visible.sync="dialogFormVisibleUpdate" width="20%">
					<el-form style="text-align: center;" v-if="batch==true">
						<el-form-item label="渠道">
							<el-select placeholder="全部渠道" v-model="MiniChann_id" @change="MInEUnu">
								<el-option v-for="item in option4" :key="item.id" :label="item.name" :value="item.id"></el-option>
							</el-select>
						</el-form-item>
					</el-form>
					<el-form>
						<el-form-item label="跟进人">
							<el-select placeholder="全部留言" v-model="Update_User.User">
								<el-option v-for="item in option3" :key="item.id" :label="item.nickName" :value="item.id"></el-option>
							</el-select>
						</el-form-item>
					</el-form>

					<div slot="footer" class="dialog-footer">
						<el-button @click="dialogFormVisibleUpdate = false">取 消</el-button>
						<el-button type="primary" @click="Update_UserModel" v-if="batch==false">确 定</el-button>
						<el-button type="primary" @click="Update_UserModelbatch" v-if="batch==true">批量确定</el-button>
					</div>
				</el-dialog>
				<div class="aside" v-if="show1" v-loading="userInfoLoading">
					<div class="reply">
						<div class="flex-title">
							快捷回复
							<el-button @click="tagProcessed" :disabled="selectedRow.ProcessingState=='已处理'">
								{{
								selectedRow.ProcessingState=='已处理'?'已处理':'设置为已处理'
								}}
							</el-button>
						</div>
						<div class="talk">
							<div class="container" id="testDiv">
								<p v-if="chatBoxLoading">{{loadingText}}</p>
								<div
									:key="index"
									:class="item.dialogues[0].sender==2?'talk_right':'talk_left'"
									v-for="(item,index) in dialogues"
								>
									<div class="content" v-if="item.dialogues[0].sender===2">
										<div class="text">
											<span :key="index" v-for="(items,index) in item.dialogues">
												<img v-if="items.messageType===2" :src="items.content" />
												<video 
													v-else-if="items.messageType===3" 
													:src="items.content"
													width="150px" 
													autoplay 
													muted
													controls 
												></video>
												<span v-else>{{items.content}}</span>
											</span>
										</div>
										<div class="creatime">{{formatTime(item.sendTime)}}</div>
									</div>
									<div class="heading" v-if="item.dialogues[0].sender==2">
										<img :src="defaultKfHeadimg" />
									</div>
									<div class="heading" v-if="item.dialogues[0].sender==1">
										<img :src="consultHeadImg" />
									</div>
									<div class="content" v-if="item.dialogues[0].sender==1">
										<div class="text">
											<span :key="index" v-for="(items,index)  in item.dialogues">
												<img v-if="items.messageType===2" :src="items.content" />
												<video 
													v-else-if="items.messageType===3" 
													:src="items.content"
													width="150px" 
													autoplay 
													muted
													controls 
												></video>
												<span v-else>{{items.content}}</span>
											</span>
										</div>
										<div class="creatime">{{formatTime(item.sendTime)}}</div>
									</div>
								</div>
							</div>
						</div>
						<textarea
							id="charInput"
							v-model="replyMessage"
							class="charInput"
							placeholder="请输入文字按回车(Enter)键发送"
							@keyup.enter="sendMessage"
						></textarea>
					</div>
					<!-- :currentUserInfo="currentUserInfo" -->
					<userinfo
						:addressList="addressList"
						:openid="selectedOpenid"
						:channelName="channelName"
						:consultationTypes="consultationTypes"
						:accessChatId="selectedAccessId"
						:onLoading="(val)=>{userInfoLoading=val}"
						@updUserInfo="updUserInfo"
						@saveCustomerCenter="saveCustomerCenter"
					/>
					<a class="close" @click="close">x</a>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import userinfo from '../../customer/talks/userInfo'
import { FormatTimes } from '@/utils/FormatTime'
import { DateTime } from '@/utils/common'
import consultationTypeTree  from '../../customer/talks/consultationTypeTree.vue'
import productTree from '../../customer/talks/productTree.vue'
export default {
	name: 'manage',
	props: [],
	components: {
		userinfo,
		consultationTypeTree,
		productTree
	},
	data() {
		return {
			MiniChann_id: 0,
			batch: true,
			disabled1: true,
			//选中的删除
			DeleteFastreply: [],
			dialogFormVisibleUpdate: false,
			Select_Message: {
				consultName: '',
				NickName: '',
				CreateTime: [],
				State: 0,
				ProcessingState: 0,
				followUp: -1,
				channelId: -1, //渠道Id
				consultationTypeId: -1,
			},
			option1: [
				{
					roleName: '全部',
					id: 0,
				},
			],
			option2: [
				{
					roleName: '全部',
					id: 0,
				},
			],
			option3: [],
			option4: [], //渠道
			tableData: [],
			SumUser: 0,
			SumUser1: 0,
			Update_User: {
				User: 0,
				id: 0,
			}, //修改时的跟进人
			followUp: [],
			exportLoading: false,
			dialogues: [],
			show1: false,
			userInfoLoading: false,
			chatBoxLoading: false,
			currentUserInfo: {},
			addressList: [],
			dialoguepagination: {
				pageIndex: 1,
				pageSize: 10,
				total: 0,
			},
			replyMessage: '',
			channelName: '',
			defaultKfHeadimg: '',
			mesRecordLoading: false,
			channelEnumList: [],
			selectedRow: {},
			consultationTypes: [],
			pickerOptions: {
				shortcuts: [
					{
						text: '最近一周',
						onClick(picker) {
							const end = new Date()
							const start = new Date()
							start.setTime(
								start.getTime() - 3600 * 1000 * 24 * 7
							)
							picker.$emit('pick', [start, end])
						},
					},
					{
						text: '最近一个月',
						onClick(picker) {
							const end = new Date()
							const start = new Date()
							start.setTime(
								start.getTime() - 3600 * 1000 * 24 * 30
							)
							picker.$emit('pick', [start, end])
						},
					},
					{
						text: '最近三个月',
						onClick(picker) {
							const end = new Date()
							const start = new Date()
							start.setTime(
								start.getTime() - 3600 * 1000 * 24 * 90
							)
							picker.$emit('pick', [start, end])
						},
					},
				],
			},
			currentNodeKey:[],
			currentNodeKeyProduct:[],
			contactSpecificationsList:[],
			crisisList:[]
		}
	},
	watch: {},
	props: {
		initData: {
			type: Object,
			default: {},
		},
	},
	mounted: function () {
		this.List(1)
		this.getAllFollowUp()
		this.getMiniChannelEnum()
	},
	created: function () {
		let vm = this
		this.getConsultationTypes()
		if (Object.keys(vm.initData).length > 0) {
			if (vm.initData.type == 'leaMsgChannelId') {
				vm.Select_Message.channelId = vm.initData.typeId
			}
			if (vm.initData.type == 'handle') {
				vm.Select_Message.channelId = vm.initData.typeObj.channelId
				vm.Select_Message.ProcessingState =
					vm.initData.typeObj.processingState
			}
			if (vm.initData.type == 'handle1') {
				vm.Select_Message.ProcessingState = vm.initData.typeObj.typeId
			}
			vm.Select_Message.CreateTime.push(
				vm.initData.startTime.replace('T', ' ')
			)
			vm.Select_Message.CreateTime.push(
				vm.initData.endTime.replace('T', ' ')
			)
			vm.$emit('clareInitData')
		}
		this.defaultKfHeadimg = localStorage.getItem('defaultKfHeadimg')
		this.consultHeadImg = localStorage.getItem('defaultConsultHeadimg')
		this.Total()
		this.SelectList()
		this.getContactSpecifications();
		this.getCrisisEnum();
	},
	methods: {
		formatTime(time) {
			if (time == null || time == undefined) {
				return '--'
			}
			return FormatTimes(time, 'yyyy-MM-dd hh:mm:ss')
		},
		getAllFollowUp() {
			let vm = this
			this.axios
				.post('CustomerMessage/getAllFollowUp')
				.then(function ({ data }) {
					vm.followUp = data
				})
		},
		SelectList() {
			let $this = this
			$this.option1 = []
			$this.option2 = []
			$this.option4 = []
			// $this.option3=[];

			this.axios
				.get('CustomerMessage/EnumCutomerMessage_allocation', {
					headers: {
						'Content-Type': 'application/json',
					},
				})
				.then(function (data) {
					data.data.forEach((element) => {
						$this.option2.push(element)
					})
				})

			this.axios
				.get('CustomerMessage/EnumCutomerMessage_dispose', {
					headers: {
						'Content-Type': 'application/json',
					},
				})
				.then(function (data) {
					data.data.forEach((element) => {
						$this.option1.push(element)
					})
				})

			this.axios
				.get('MiniChannelEnum/SelectList', {
					headers: {
						'Content-Type': 'application/json',
					},
				})
				.then(function (data) {
					data.data.forEach((element) => {
						$this.option4.push(element)
						$this.MiniChann_id = $this.option4[0].id
					})
				})

			// this.axios.get("User/Select",{
			//   headers:{
			//     'Content-Type':'application/json'
			//   }
			// }).then(function(data){
			//   data.data.forEach(element => {

			//       $this.option3.push(element);
			//   });
			// })
		},
		Total() {
			let $this = this
			var Create_Model = $this.Select_Message.CreateTime
			
			var CreateTime = ''
			var CreateTime1 = ''
			var NickName = $this.Select_Message.NickName
			if (Create_Model != null && Create_Model != '') {
				var CreateTime = Create_Model[0]
				var CreateTime1 = Create_Model[1]
			}
			var State = $this.Select_Message.State
			var ProcessingState = $this.Select_Message.ProcessingState
			//初始化  留言总人数
			this.axios
				.get(
					'CustomerMessage/SumCustomer',
					{
						params: {
							NickName: NickName,
							CreateTime: CreateTime,
							CreateTime1: CreateTime1,
							State: State,
							ProcessingState: ProcessingState,
							followUp: $this.Select_Message.followUp,
							channelId: $this.Select_Message.channelId,
							consultationTypeId:$this.Select_Message.consultationTypeId,
							contactSpecificationsId:$this.Select_Message.contactSpecificationsId,
							crisisId:$this.Select_Message.crisisId,
							productId:$this.Select_Message.productId
						},
					},
					{
						headers: {
							'Content-Type': 'application/json',
						},
					}
				)
				.then(function (data) {
					
					$this.SumUser = data.data
					if ($this.SumUser1 == 0) {
						$this.SumUser1 = $this.SumUser
					}
				})
		},
		p(s) {
			return s < 10 ? '0' + s : s
		},
		//返回用户列表
		List(PageSize, PageNum) {
			let $this = this

			var Create_Model = $this.Select_Message.CreateTime
			var CreateTime = ''
			var CreateTime1 = ''
			var Content = $this.Select_Message.NickName
			if (Create_Model != null && Create_Model != '') {
				var CreateTime = Create_Model[0]
				var CreateTime1 = Create_Model[1]
			}
			var State = $this.Select_Message.State
			var ProcessingState = $this.Select_Message.ProcessingState

			PageNum = 10
			$this.mesRecordLoading = true
			this.axios
				.get(
					'CustomerMessage/CustomerList',
					{
						params: {
							pages: PageSize,
							pageNum: PageNum,
							Content: Content,
							CreateTime: CreateTime,
							CreateTime1: CreateTime1,
							State: State,
							ProcessingState: ProcessingState,
							followUp: $this.Select_Message.followUp,
							channelId: $this.Select_Message.channelId,
							consultationTypeId:$this.Select_Message.consultationTypeId,
							contactSpecificationsId:$this.Select_Message.contactSpecificationsId,
							crisisId:$this.Select_Message.crisisId,
							productId:$this.Select_Message.productId
						},
					},
					{
						headers: {
							'Content-Type': 'application/json',
						},
					}
				)
				.then(function (data) {
					$this.tableData = []
					data.data.forEach((element) => {
						$this.tableData.push({
							NickName: element.nickName,
							Content: element.content,
							createTime: element.createTime,
							State: element.state,
							AllocationTime: element.allocationTime,
							UserName: element.userName,
							operate: element.id,
							ProcessingState: element.processingState,
							Name: element.name,
							MiniChannelId: element.miniChannelEnum_Id,
							openid: element.openId,
							accessChatId: element.accessChatId,
							completionTime: element.completionTime,
							typeName: element.typeName,
							typeNameTree:element.typeNameTree,
							contactSpecificationsName:element.contactSpecificationsName,
							crisisName:element.crisisName,
							productNameTree:element.productNameTree,
							productName:element.productName

						})
						console.debug(element.completionTime)
						// $this.tableData.forEach(element => {
						// 	if (
						// 		element.SendTime != '' &&
						// 		element.SendTime != null
						// 	) {
						// 		element.SendTime = element.SendTime.replace(
						// 			'T',
						// 			' '
						// 		)
						// 	}
						// 	if (
						// 		element.AllocationTime != '' &&
						// 		element.AllocationTime != null
						// 	) {
						// 		element.AllocationTime = element.AllocationTime.replace(
						// 			'T',
						// 			' '
						// 		)
						// 	}
						// })
					})
					$this.mesRecordLoading = false
				})
		},
		Select_List() {
			this.List()
			this.Total()
		},
		//修改弹框
		Update(id, MiniChannelId) {
			this.dialogFormVisibleUpdate = true

			let $this = this
			if (id == 0) {
				$this.batch = true
				MiniChannelId = $this.MiniChann_id
			} else {
				$this.batch = false
			}
			$this.option3 = []
			this.axios
				.get(
					'CustomerMessage/UserGroupRelation',
					{
						params: {
							MiniChannelId: MiniChannelId,
						},
					},
					{
						headers: {
							'Content-Type': 'application/json',
						},
					}
				)
				.then(function (data) {
					data.data.forEach((element) => {
						$this.option3.push(element)
					})
				})

			// Update_User
			$this.Update_User.id = id
			this.axios
				.get(
					'CustomerMessage/FollowUserId',
					{
						params: {
							id: id,
						},
					},
					{
						headers: {
							'Content-Type': 'application/json',
						},
					}
				)
				.then(function (data) {
					if (data.data == '') {
						$this.Update_User.User = $this.option3[0].id
					} else {
						$this.Update_User.User = data.data
					}
				})
		},
		Update_UserModel() {
			let $this = this
			this.axios
				.post(
					'CustomerMessage/Update_CustomerMessage?Id=' +
						$this.Update_User.id +
						'&FollowUserId=' +
						$this.Update_User.User
				)
				.then(function (data) {
					if (data.data.message == '成功') {
						$this.dialogFormVisibleUpdate = false
						$this.List()
						$this.Total()
					} else {
						$this.$message.error(data.data.message);
					}
				})
		},
		//批量分配
		Update_UserModelbatch() {
			let $this = this
			var IDD = ''
			var shu = 1
			// console.log($this.DeleteFastreply);
			$this.DeleteFastreply.forEach((element) => {
				if (shu == $this.DeleteFastreply.length) {
					IDD += element
				} else {
					IDD += element + ','
				}
				shu++
			})

			this.axios
				.post(
					'CustomerMessage/Update_CustomerMessagebatch?Id=' +
						IDD +
						'&FollowUserId=' +
						$this.Update_User.User
				)
				.then(function (data) {
					if (data.data.message == '成功') {
					 
						$this.$message(data.data.message)
						$this.dialogFormVisibleUpdate = false
						$this.List()
						$this.Total()

						$this.disabled1 = false
					} else {
					 
						$this.$message.error(data.data.message)
					}
				})
		},
		//选择单个
		selectCheck(selection, row) {
			let $this = this
			$this.DeleteFastreply = []
			selection.forEach((element) => {
				var elem = element.operate
				$this.DeleteFastreply.push(elem)
			})

			if ($this.DeleteFastreply.length > 0) {
				$this.disabled1 = false
			} else {
				$this.disabled1 = true
			}
		},
		//选中全部
		select_allCheckk(selection) {
			let $this = this
			$this.DeleteFastreply = []
			selection.forEach((element) => {
				var elem = element.operate
				$this.DeleteFastreply.push(elem)
			})
			if ($this.DeleteFastreply.length > 0) {
				$this.disabled1 = false
			} else {
				$this.disabled1 = true
			}
		},
		MInEUnu() {
			let $this = this
			$this.option3 = []
			this.axios
				.get(
					'CustomerMessage/UserGroupRelation',
					{
						params: {
							MiniChannelId: $this.MiniChann_id,
						},
					},
					{
						headers: {
							'Content-Type': 'application/json',
						},
					}
				)
				.then(function (data) {
					data.data.forEach((element) => {
						$this.option3.push(element)
					})
				})
		},
		//导出
		export1() {
			let $this = this
			var Create_Model = $this.Select_Message.CreateTime
			var CreateTime = ''
			var CreateTime1 = ''
			var Content = $this.Select_Message.NickName
			if (Create_Model != null && Create_Model != '') {
				var d = new Date(Create_Model[0].replace(' ', 'T'))
				var d1 = new Date(Create_Model[1].replace(' ', 'T'))
				CreateTime =
					d.getFullYear() +
					'-' +
					this.p(d.getMonth() + 1) +
					'-' +
					this.p(d.getDate())
				CreateTime1 =
					d1.getFullYear() +
					'-' +
					this.p(d1.getMonth() + 1) +
					'-' +
					this.p(d1.getDate())
			}
			var State = $this.Select_Message.State
			var ProcessingState = $this.Select_Message.ProcessingState
			var channelId = $this.Select_Message.channelId
			$this.exportLoading = true
			this.axios
				.post(
					'CustomerMessage/Exprot_Numberofdays_Exprot', 
					{
						 
							contactSpecificationsId:$this.Select_Message.contactSpecificationsId,
							crisisId:$this.Select_Message.crisisId,
							Content:Content,
							CreateTime:CreateTime,
							CreateTime1:CreateTime1,
							State:State,
							ProcessingState:ProcessingState,
							channelId:channelId,
							productId:$this.Select_Message.productId
						 
					},
					{
						responseType: 'blob', //设置响应的数据类型为一个包含二进制数据的 Blob 对象，必须设置！！！
					}
				)
				.then(function (res) {
					let filename = '留言记录.xls'
					let blob = res.data
					let reader = new FileReader()
					reader.readAsDataURL(blob)
					reader.onload = (e) => {
						//创建a标签，插入到文档中并click，最后移除
						let a = document.createElement('a')
						a.download = filename
						a.href = e.target.result
						document.body.appendChild(a)
						a.click()
						document.body.removeChild(a)
						$this.exportLoading = false
						$this.$message({ type: 'success', message: '导出成功' })
					}
				})
		},
		rowClick(val) {
			let vm = this
			vm.show1 = true
			vm.selectedAccessId = val.accessChatId
			vm.selectedOpenid = val.openid
			vm.selectedMessageId = val.operate

			vm.selectedRow = val
			vm.channelName = val.channelName
			vm.getUserInfo(val.openid, val.accessChatId)
			vm.getDialogue()
		},
		getDialogue() {
			let vm = this
			var obj = new Object()
			obj.accessChatId = vm.selectedAccessId
			obj.pagination = vm.dialoguepagination
			this.axios
				.post('Dialogue/getLeaving', obj)
				.then(function ({ data }) {
					if (data.result) {
						console.log(JSON.stringify(data.data.list))
						vm.dialogues = data.data.list

						vm.dialoguepagination = data.data.pagination
					}
					vm.chatBoxLoading = false
				})
		},
		close() {
			let vm = this
			vm.show1 = false
		},
		tagProcessed() {
			let vm = this
			this.axios
				.get('CustomerMessage/UpdLavState', {
					params: {
						customerMessageId: vm.selectedMessageId,
						state: 1, //1 已处理 2 未处理
					},
				})
				.then(function ({ data }) {
					if (data.result) {
						vm.List(1)
						vm.show1 = false
						vm.$message({
							message: '标记成功',
							type: 'success',
						})
					} else {
						vm.$notify.error({
							title: '错误',
							message: data.message,
						})
					}
				})
		},
		updUserInfo(val) {
			let vm = this
			this.axios
				.post('ConsultantInfo/updUserInfo', val)
				.then(function ({ data }) {
					if (!data.result) {
						vm.$notify.error({
							title: '错误',
							message: data.message,
						})
					}
				})
		},
		getUserInfo(openid, accessChatId) {
			let vm = this
			if (openid == '' || accessChatId == 0) {
				return
			}
			vm.userInfoLoading = true
			this.axios
				.get('ConsultantInfo/getUserInfo', {
					params: { openid: openid, accessChatId: accessChatId },
				})
				.then(function ({ data }) {
					if (data.result) {
						vm.currentUserInfo = data.data
					} else {
						vm.$notify.error({
							title: '错误',
							message: data.message,
						})
					}
					vm.userInfoLoading = false
				})
		},
		saveCustomerCenter(val) {
			let vm = this
			val.accessChatId = vm.selectedAccessId
			this.axios
				.post('AccessChat_Subtotal', val)
				.then(function ({ data }) {
					if (!data.result) {
						vm.$notify.error({
							title: '错误',
							message: data.message,
						})
					} else {
						vm.$message({ type: 'success', message: '保存成功' })
					}
				})
		},
		getAddress() {
			let vm = this
			this.axios.get('Address/GetAdd').then(function ({ data }) {
				if (data.result) {
					vm.addressList = data.data
				}
			})
		},
		sendMessage() {
			let date = new DateTime()
			let str = date.Now()
			let vm = this
			let send = new Object()
			var array = []
			var obj = new Object()
			obj.consultId = vm.selectedOpenid
			obj.sender = 2
			obj.content = vm.replyMessage.replace('\n', '')
			obj.messageType = 1
			obj.accessChatId = vm.selectedAccessId
			array.push(obj)
			send.Receiver = vm.selectedOpenid
			send.dialogues = array
			send.sendTime = str
			vm.replyMessage = ''
			vm.dialogues.push(send)
			let sendobj = { ...send }
			vm.$delete(sendobj, 'sendTime')
			this.axios
				.post('SendMessage/ReplyMessage', sendobj)
				.then(function ({ data }) {})
		},
		getMiniChannelEnum() {
			let vm = this
			this.axios
				.get('MiniChannelEnum/SelectList')
				.then(function ({ data }) {
					
					vm.channelEnumList = data
				})
		},
		getConsultationTypes() {
			let vm = this
			this.axios
				.get('ConsultationTypes/getConsultTypes')
				.then(function ({ data }) {
					if (data.result) {
						vm.consultationTypes = data.data
					}
				})
		},
		exportLeavingAMessage(accessChatId) {
			let arr = []
			arr.push(accessChatId)
			let vm = this
			this.axios
				.post('Dialogue/ExportLeavingAMsg', arr, {
					responseType: 'blob',
				})
				.then(function (res) {
					let filename = '留言对话.xls'
					let blob = res.data
					let reader = new FileReader()
					reader.readAsDataURL(blob)
					reader.onload = (e) => {
						//创建a标签，插入到文档中并click，最后移除
						let a = document.createElement('a')
						a.download = filename
						a.href = e.target.result
						document.body.appendChild(a)
						a.click()
						document.body.removeChild(a)
						$this.exportLoading = false
						$this.$message({ type: 'success', message: '导出成功' })
					}
				})
		},
		onSelectedId(val){
			this.currentNodeKey=val;
			if(val.length==0){
				this.Select_Message.consultationTypeId=-1;
			}else{
				this.Select_Message.consultationTypeId=val[0];
			}
		},
		onSelectedProductId(val){
			this.currentNodeKeyProduct=val;
			if(val.length==0){
				this.Select_Message.productId = -1;
			}else{
				this.Select_Message.productId=val[0];
			}
		},
		getContactSpecifications(){
			let vm =this;
			
			this.axios.get('/ContactSpecifications').then(function({data}){
				vm.contactSpecificationsList=data.data
			})
		},
		getCrisisEnum(){
	
			let vm =this;
			
			this.axios.get('/CrisisEnum').then(function({data}){
				vm.crisisList=data.data
			})
		}
	},
}
</script>

<style scoped>
.talk_left {
	display: -webkit-flex; /*在webkit内核的浏览器上使用要加前缀*/
	display: flex;
	justify-content: flex-start;
	align-items: flex-start;
	margin-bottom: 10px;
	min-width: 100px;
}
.talk_left .content {
	margin-left: 10px;
}
.talk_left .content img {
	max-width: 195px;
}
.text {
	max-width: 195px;
	padding: 15px;
	background-color: #dcedf9;
	border-radius: 5px;
	font-size: 14px;
	letter-spacing: 1px;
}
.talk_left .text::after {
	position: absolute;
}
.talk_right {
	display: -webkit-flex; /*在webkit内核的浏览器上使用要加前缀*/
	display: flex;
	justify-content: flex-end;
	align-items: flex-start;
	margin-bottom: 10px;
}
.talk_right .content {
	margin-right: 10px;
}
.talk_right .content img {
	max-width: 225px;
}
.heading {
	width: 40px;
	height: 40px;
	border-radius: 50%;
}
.heading img {
	width: 100%;
	height: 100%;
	border-radius: 50%;
}
.aside {
	position: fixed;
	top: 62px;
	right: 0;
	height: 100%;
	width: 740px;
	background-color: #fff;
	z-index: 500;
	box-shadow: -4px -1px 4px 1px rgba(0, 0, 0, 0.1);
}
.close {
	display: block;
	position: absolute;
	width: 30px;
	height: 30px;
	line-height: 28px;
	text-align: center;
	background-color: #fff;
	left: -30px;
	top: 20px;
	font-size: 16px;
	color: #999;
	box-shadow: -2px -1px 2px 1px rgba(0, 0, 0, 0.1);
}
/*留言详情*/
.reply {
	width: 50%;
	display: inline-block;
	float: left;
	border-right: 1px solid #ddd;
	box-sizing: border-box;
	height: 100%;
}
.flex-title {
	display: -webkit-flex; /*在webkit内核的浏览器上使用要加前缀*/
	display: flex;
	justify-content: space-between;
	align-items: center;
	height: 42px;
	line-height: 42px;
	border-bottom: 1px solid #ddd;
	padding: 0 15px;
}
.talk {
	padding: 30px 10px 10px 10px;
	height: 60%;
	border-bottom: 1px solid #ddd;
	overflow-y: auto;
	overflow-x: hidden;
}
.search-box {
	line-height: 44px;
	border-bottom: 1px solid #ddd;
}
.search-box .el-input-group {
	width: 320px;
}
.talk p {
	text-align: center;
	color: #bbb;
	line-height: 30px;
}
.container {
	overflow-x: hidden;
	overflow-y: auto;
}
.charInput {
	display: block;
	width: 300px;
	padding: 5px 15px;
	min-height: 120px;
	max-height: 120px;
	outline: none;
	font-size: 14px;
	line-height: 30px;
	word-wrap: break-word;
	margin: 30px auto 0;
	background-color: #f1f1f1;
	border: 1px solid #ddd;
	resize: none;
}
.creatime {
	color: #999;
	padding: 5px 10px 5px 50px;
	margin-bottom: 10px;
}
.kefu-user /deep/ .aside .userinfor {
	width: 50%;
	display: inline-block;
	float: right;
}
.Message_Sum {
	font-size: 18px;
	margin-top: 15px;
	float: left;
	margin-left: 10px;
}
.Message_Sum > span {
	color: #6a9bec;
}

/* 
  .is-leaf{
      border-right: 0px
  } */

.include {
	border: 1px solid #eeeeee;
}
.search_box .el-input__inner {
	background-color: transparent;
	border: none;
	height: 30px;
	line-height: 30px;
}
.el-input__icon {
	line-height: 28px;
}
.contains {
	height: 100%;
	overflow: auto;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-orient: vertical;
	-webkit-box-direction: normal;
	-ms-flex-direction: column;
	flex-direction: column;
	position: relative;
	padding-top: 10px;
	width: 100%;
	-webkit-box-sizing: border-box;
	box-sizing: border-box;
}
.content-tit {
	height: 60px;
	line-height: 46px;
}
.content-tit h2 {
	font-weight: normal;
	font-size: 22px;
}
.kefu-group {
	width: 250px;
	text-align: left;
	border: solid 1px #ddd;
	overflow-x: hidden;
	min-width: 250px;
}
.groupmag-hd {
	min-height: 40px;
	display: flex;
	line-height: 40px;
	border-bottom: solid 1px #ddd;
	padding: 0 8px;
	background-color: #f7f7fa;
}
.groupmag-hd .tit {
	min-width: 100px;
	font-size: 14px;
	padding-left: 8px;
}
.groupmag-hd .opr {
	text-align: right;
	width: 100%;
}
.groupmag-hd .opr a {
	margin-right: 10px;
	color: #337eff;
}
.m-groupmag {
	height: 100%;
	display: flex;
	flex-direction: column;
}
.content-main {
	display: flex;
	position: relative;
	height: calc(100% - 60px);
}
.m-groupmag .m-grouptree .treesearch {
	padding: 10px 15px;
}
.treesearch .inp-wrap {
	border: solid 1px #ddd;
	position: relative;
}
.treesearch .inp-wrap input {
	width: 80%;
	border: none;
	height: 30px;
	padding-left: 10px;
}

.treesearch .inp-wrap .iconfont {
	position: absolute;
	top: 5px;
	right: 8px;
	color: #999;
}
.icon-search:before {
	content: '\e60b';
}
.treelist {
	padding: 0 15px;
}
.beginnodes {
	list-style: none;
}
.treenode .nodename {
	line-height: 30px;
	min-height: 30px;
	color: #999;
	font-size: 14px;
}

.treenode .nodename .nameline:hover span {
	color: #337eff;
}
.treenode .nodename .nameline .icon-L {
	margin-left: 8px;
	position: relative;
	top: -5px;
	color: #999;
}
.treenode .nodename .nameline:hover .icon-L {
	color: #999;
}
.oprs {
	padding-left: 38px;
	color: #337eff;
	font-size: 12px;
}
.oprs a {
	margin-right: 4px;
}
.icon-edit {
	font-size: 14px;
}

/*表格*/
.kefu-user {
	width: 100%;
	height: 100%;
}
.content-box {
	padding: 20px;
}
.title {
	font-size: 16px;
	padding: 0px 0 20px 0;
	float: left;
}
.content-box .el-input-group {
	/* float: right; */
	width: 320px;
}
.add {
	float: right;
}
.import {
	float: right;
}
.export {
	float: right;
	margin-right: 10px;
}
.delete {
	float: right;
	margin-right: 10px;
}
.staff_box .el-select {
	/* float: right; */
	width: 140px;
	/* margin-left: 15px; */
}
.staff_box .row {
	float: right;
	margin-bottom: 10px;
}
.search_box {
	border: 1px solid #dcdfe6;
	background-color: #fafafa;
	padding-right: 10px;
	margin: 0 5px 0 15px;
	border-radius: 4px;
}
.icon-sousuo {
	font-size: 20px;
	cursor: pointer;
	vertical-align: middle;
}
.batch {
	float: right;
	margin-right: 15px;
	background-color: #999999;
	border-color: #999;
}
.table_box {
	margin-top: 50px;
}
.pagination {
	text-align: right;
}
.el-pagination {
	text-align: right;
	margin-top: 50px;
	display: inline-block;
}
.el-table--striped .el-table__body tr.el-table__row--striped td {
	background: white;
}
.el-table--border td,
.el-table--border th,
.el-table__body-wrapper .el-table--border.is-scrolling-left ~ .el-table__fixed {
	border-right: 0px;
}
/* .el-table--striped .el-table__body tr.el-table__row--striped td{
      background: #FFF
  }
    .el-table thead{
        background:#EBEEF5
    } */
.el-table--border td,
.el-table--border th,
.el-table__body-wrapper .el-table--border.is-scrolling-left ~ .el-table__fixed {
	border-right: 0px;
}
.el-table__row > th {
	border-right: 0px;
}
</style>





// WEBPACK FOOTER //
// src/components/manage/system/Message record.vue